import React from 'react';
import Hero from '../components/home/Hero';
import LogoStrip from '../components/home/LogoStrip';
import PipelineToggle from '../components/home/PipelineToggle';
import FeaturesGrid from '../components/home/FeaturesGrid';
import InteractiveDemo from '../components/home/InteractiveDemo';
import ComparisonTable from '../components/home/ComparisonTable';
import Testimonials from '../components/home/Testimonials';
import CTASection from '../components/home/CTASection';

const Home = () => {
  return (
    <>
      <Hero />
      <LogoStrip />
      <PipelineToggle />
      <FeaturesGrid />
      <InteractiveDemo />
      <ComparisonTable />
      <Testimonials />
      <CTASection />
    </>
  );
};

export default Home;